var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48.308,
    height: 48.308,
    viewBox: "0 0 48.308 48.308",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-close-circle",
    "data-name": "Icon ionic-ios-close-circle",
    d: "M27.529,3.375A24.154,24.154,0,1,0,51.683,27.529,24.15,24.15,0,0,0,27.529,3.375Zm6.12,32.9-6.12-6.12-6.12,6.12a1.856,1.856,0,1,1-2.624-2.624l6.12-6.12-6.12-6.12a1.856,1.856,0,0,1,2.624-2.624l6.12,6.12,6.12-6.12a1.856,1.856,0,1,1,2.624,2.624l-6.12,6.12,6.12,6.12a1.864,1.864,0,0,1,0,2.624A1.843,1.843,0,0,1,33.649,36.273Z",
    transform: "translate(-3.375 -3.375)",
    fill: "#959da6"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/Cross.298cdd71247473655cce8b75504e640f.svg";
export { ForwardRef as ReactComponent };